import React, { useEffect, useRef, useState } from 'react';
import { Icon } from 'ensightful-koala-ui';
import styled from 'styled-components';

import { TextButton } from 'components/molecules/Button';
import DropDown from 'components/organisms/DropDown/DropDown';
import useClickOutside from 'services/hooks/useClickOutside';
import { OverFlowBody2 } from 'components/atoms/Text';

const Container = styled.div`
    position: relative;
`;

const StyledTextButton = styled(TextButton)`
    width: ${(props) => (props.width ? props.width : 'fit-content')};
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #424242;
    padding: ${(props) => (props.bordered ? '16px 16px' : '0')};
    font-size: 14px;
    font-weight: normal;
    letter-spacing: 0.1px;
    line-height: 20px;
    cursor: pointer;
    border: ${(props) => (props.bordered ? '1px solid #9E9E9E' : 'none')};
    border-radius: 6px;

    &:hover {
        color: #6347ff;

        & > svg {
            opacity: 1;
        }
    }

    &:disabled {
        cursor: default;
    }

    & > svg {
        margin-left: 8px;
        opacity: 0;
        transition: all 200ms;

        & > path {
            fill: #bdbdbd;
        }
    }
`;

const StyledDropDown = styled(DropDown)`
    width: ${(props) => (props.width ? props.width : 'fit-content')};
    max-width: ${(props) => (props.width ? '100%' : '400px')};
    top: ${(props) => (props.bordered ? '50px' : '24px')};
    left: 0px;
    padding: 8px;
`;

const ButtonDropDown = ({
    id,
    className,
    disabled = false,
    bordered = false,
    content = null,
    renderOption,
    itemList = [],
    value,
    index,
    onChange,
    onOpenChange = () => {},
    onKeyPress = () => null,
    type = '',
    ...rest
}) => {
    const dropDownRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);

    const handleSelect = (e, value) => {
        onKeyPress(e);
        onChange(value);
        setIsOpen(false);
    };

    useClickOutside(dropDownRef, () => {
        setIsOpen(false);
    });

    useEffect(() => {
        if (isOpen) dropDownRef.current.focus();
    }, [isOpen]);

    useEffect(() => {
        onOpenChange(isOpen);
    }, [isOpen]);

    return (
        <Container className={className}>
            <StyledTextButton id={id} disabled={disabled} bordered={bordered} onClick={() => setIsOpen(true)} {...rest}>
                <OverFlowBody2
                    as={'div'}
                    style={{ color: value?.title ? 'black' : '#757575' }}
                    maxWidth={rest.width ? rest.width : '200px'}
                >
                    {content ? content() : value?.title || rest.placeholder}{' '}
                </OverFlowBody2>
                {!disabled && <Icon kind={'drop-down-arrow'} fill={'#757575'} />}
            </StyledTextButton>
            <StyledDropDown
                currentSelection={value}
                id={id}
                ref={dropDownRef}
                open={isOpen}
                bordred={bordered}
                renderOption={renderOption}
                itemList={itemList}
                handleSelected={handleSelect}
                handleKeyPress={onKeyPress}
                handleCancel={() => setIsOpen(false)}
                type={type}
                {...rest}
            />
        </Container>
    );
};

export default ButtonDropDown;
